// src/components/ScrollReveal.js
// Wraps children in a fade-up animation triggered on scroll.
// Usage: <ScrollReveal><YourContent /></ScrollReveal>

import React from 'react';
import { Box } from '@mui/material';
import useScrollReveal from '../hooks/useScrollReveal';

const ScrollReveal = ({ children, delay = 0 }) => {
  const { ref, isVisible } = useScrollReveal();

  return (
    <Box
      ref={ref}
      sx={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(32px)',
        transition: `opacity 0.7s ease ${delay}s, transform 0.7s ease ${delay}s`,
      }}
    >
      {children}
    </Box>
  );
};

export default ScrollReveal;
